@if (visible) {
  <div
    class="tw-flex tw-items-center tw-gap-3 tw-bg-white tw-rounded-lg tw-shadow-sm tw-p-4 tw-mx-2.5 md:!tw-mx-auto tw-mt-[15px]"
  >
    <mat-icon
      aria-hidden="true"
      svgIcon="integration-microsoft"
      class="tw-shrink-0 !tw-w-6 !tw-h-6"
    ></mat-icon>
    <p
      class="tw-flex-1 tw-min-w-0 tw-m-0 tw-text-sm tw-leading-5 tw-text-gray-700"
    >
      Get remote touchback control and other advanced features with
      <span class="tw-font-semibold">Rise Vision Share,</span> our free desktop
      app for Windows.
      <button
        type="button"
        class="tw-p-0 tw-border-0 tw-bg-transparent tw-font-medium tw-text-rise-green-700 tw-whitespace-nowrap"
        (click)="learnMore()"
      >
        Learn more →
      </button>
    </p>
    <!-- The button overhangs the 20px text row, as in the design, so it doesn't set the banner's height. -->
    <button
      type="button"
      class="tw-shrink-0 tw-flex tw-items-center tw-justify-center tw-h-10 -tw-my-2.5 tw-px-2.5 tw-rounded-md tw-border-0 tw-bg-transparent tw-text-gray-900 hover:tw-bg-gray-100"
      aria-label="Dismiss"
      (click)="dismiss()"
    >
      <mat-icon
        aria-hidden="true"
        svgIcon="close"
        class="!tw-w-5 !tw-h-5"
      ></mat-icon>
    </button>
  </div>
}
